var $46417484d64689f8$exports = {};
$46417484d64689f8$exports = {
    "invalidSelection": (args, formatter)=>`Izabrani ${formatter.plural(args.selectedCount, {
            one: `date`,
            other: `dates`
        })} nije dostupan.`
};


export {$46417484d64689f8$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
